import React from "react"

import { Form } from "@atos6/ui"
import { useStore } from "../containers"
import { InputNameStateful } from "./InputNameStateful"

export function FormItemNameStateful() {
  const { documentType } = useStore()
  const label = documentType === "cpf" ? "Nome completo" : "Razão Social"

  return (
    <Form.Item label={label}>
      <InputNameStateful />
    </Form.Item>
  )
}
